import { render, staticRenderFns } from "./resellerDemoSubscriptions.vue?vue&type=template&id=9053ab74&"
import script from "./resellerDemoSubscriptions.vue?vue&type=script&lang=js&"
export * from "./resellerDemoSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports